import { ArrowLeft, UserPlus } from 'lucide-react'
import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Label } from '@/components/ui/label'
import { Skeleton } from '@/components/ui/skeleton'
import { Textarea } from '@/components/ui/textarea'
import { useAssignTrainees } from '@/hooks/use-training-enrollments'
import { useTraining } from '@/hooks/use-trainings'
import { useTenantPath } from '@/lib/tenant'

export default function TrainingAssignPage() {
  const { id } = useParams<{ id: string }>()
  const tp = useTenantPath()
  const { data: training, isLoading } = useTraining(id ?? '')
  const assignTrainees = useAssignTrainees()
  const [userIdsText, setUserIdsText] = useState('')

  const t = training as any

  const handleAssign = async () => {
    if (!id) return
    const userIds = userIdsText
      .split(/[\n,]/)
      .map((s) => s.trim())
      .filter(Boolean)

    if (userIds.length === 0) {
      toast.error('ユーザーIDを入力してください')
      return
    }

    try {
      await assignTrainees.mutateAsync({ trainingId: id, userIds })
      toast.success(`${userIds.length}名をアサインしました`)
      setUserIdsText('')
    } catch (err) {
      toast.error(err instanceof Error ? err.message : 'アサインに失敗しました')
    }
  }

  if (isLoading) {
    return (
      <div className="space-y-6 max-w-2xl">
        <Skeleton className="h-10 w-48" />
        <Skeleton className="h-64" />
      </div>
    )
  }

  return (
    <div className="space-y-6 max-w-2xl">
      <div className="flex items-center gap-3">
        <Link to={tp('/teacher/trainings')}>
          <Button variant="ghost" size="sm">
            <ArrowLeft className="mr-1 h-4 w-4" />
            戻る
          </Button>
        </Link>
        <h1 className="text-2xl font-bold">受講者アサイン</h1>
      </div>

      {t && (
        <p className="text-muted-foreground">
          研修: <span className="font-medium text-foreground">{t.title}</span>
        </p>
      )}

      <Card>
        <CardHeader>
          <CardTitle className="text-base flex items-center gap-2">
            <UserPlus className="h-4 w-4" />
            一括アサイン
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label>ユーザーID（1行に1つ、またはカンマ区切り）</Label>
            <Textarea
              placeholder="550e8400-e29b-41d4-a716-446655440001&#10;550e8400-e29b-41d4-a716-446655440002"
              rows={6}
              value={userIdsText}
              onChange={(e) => setUserIdsText(e.target.value)}
            />
          </div>
          <Button onClick={handleAssign} disabled={assignTrainees.isPending || !userIdsText.trim()}>
            {assignTrainees.isPending ? 'アサイン中...' : 'アサイン実行'}
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
